import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTools = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_16539_111476)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.3485 4.1017C15.3264 3.98193 15.2793 3.86815 15.2104 3.76773C15.1415 3.66732 15.0523 3.58252 14.9485 3.51884L12.6627 5.80455C12.5561 5.91516 12.4283 6.00314 12.2869 6.06323C12.1456 6.12333 11.9935 6.1543 11.8399 6.1543C11.6863 6.1543 11.5342 6.12333 11.3928 6.06323C11.2515 6.00314 11.1236 5.91516 11.017 5.80455L10.1485 5.02741C9.93905 4.81378 9.82176 4.52656 9.82176 4.22741C9.82176 3.92827 9.93905 3.64104 10.1485 3.42741L12.4342 1.1417C12.3843 1.0246 12.3093 0.919881 12.2146 0.83496C12.1198 0.750039 12.0075 0.686988 11.8856 0.650268C11.0881 0.491228 10.2619 0.559306 9.50121 0.846751C8.74049 1.1342 8.07576 1.62946 7.5827 2.27616C7.08964 2.92285 6.78806 3.69499 6.7123 4.50468C6.63654 5.31436 6.78964 6.12904 7.15417 6.85598L0.91417 13.0388C0.805318 13.1453 0.718828 13.2724 0.659779 13.4127C0.60073 13.553 0.570313 13.7037 0.570312 13.856C0.570313 14.0082 0.60073 14.1589 0.659779 14.2993C0.718828 14.4396 0.805318 14.5667 0.91417 14.6731L1.3256 15.0846C1.43203 15.1934 1.55915 15.2799 1.69947 15.3389C1.83979 15.398 1.9905 15.4284 2.14274 15.4284C2.29498 15.4284 2.44569 15.398 2.58601 15.3389C2.72634 15.2799 2.85345 15.1934 2.95988 15.0846L9.19989 8.85598C9.92702 9.20242 10.736 9.34038 11.5368 9.25452C12.3377 9.16867 13.0991 8.86237 13.7362 8.36968C14.3734 7.87699 14.8614 7.21722 15.1461 6.46375C15.4307 5.71027 15.5008 4.89261 15.3485 4.1017Z",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_16539_111476",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgTools;
